import styled from 'styled-components';

const Slider = styled.div`
  width: 100%;
  height: 45px;
  position: relative;
  bottom: 0px;

  .tooltip-wrapper {
    position: absolute;
  }

  .tooltip {
    position: relative;
    overflow-wrap: break-word;
  }

  .marker-tooltip {
    right: -50%;
  }
`;

const Svg = styled.svg`
  width: 100%;
  height: 30px;

  .track,
  .track-inset {
    stroke-linecap: round;
  }

  .track {
    stroke: #000;
    stroke-opacity: 0.3;
    stroke-width: 5px;
  }

  .track-inset {
    stroke: #ddd;
    stroke-width: 3px;
  }

  .track-played {
    stroke: #f00;
    stroke-width: 3px;
  }

  .annotation {
    cursor: pointer;
  }

  .selector {
    fill: #f00;
    z-index: -10;
    cursor: crosshair;
  }

  h5.TimeRange {
    margin: 10px 10px 0px;
  }
`;

export default {
  Slider,
  Svg
};
